var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3993 7.82171L2.56436 37.5958C2.19664 38.2326 2.00208 38.9546 2.00002 39.6899C1.99796 40.4252 2.18848 41.1483 2.55262 41.7872C2.91677 42.426 3.44184 42.9584 4.07561 43.3313C4.70937 43.7042 5.42974 43.9047 6.16504 43.9128H41.835C42.5703 43.9047 43.2906 43.7042 43.9244 43.3313C44.5582 42.9584 45.0832 42.426 45.4474 41.7872C45.8115 41.1483 46.002 40.4252 46 39.6899C45.9979 38.9546 45.8034 38.2326 45.4356 37.5958L27.6007 7.82171C27.2253 7.20287 26.6968 6.69122 26.0661 6.33613C25.4354 5.98104 24.7238 5.79449 24 5.79449C23.2762 5.79449 22.5646 5.98104 21.9339 6.33613C21.3032 6.69122 20.7747 7.20287 20.3993 7.82171V7.82171Z",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.6448V27.0675",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35.4901H24.02",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon--warning.0f3669a7c1dc7da5302948a789842b15.svg";
export { ForwardRef as ReactComponent };